import React, { Component } from 'react';
import {
  Grid,
  Row,
  Col,
  Button,
} from 'react-bootstrap';
import appHistory from '../../history';

import './Landing.css';

class Header extends Component {
  render() {
    return (
      <header className="Landing-header">
        <div className="Landing-header-bg"></div>
        <Grid>
          <Row>
            <Col lg={12}>
              <div className="Landing-header-title">
                <div>BETTER</div>
                <div>CONDO LIFE.</div>
              </div>
              <div className="Landing-header-subtitle">
                Passcode.io gives you complete control over
                your building's intercom, allowing you to grant and revoke access with codes
                anytime and anywhere.
              </div>
              <div className="Landing-header-action">
                <Button className="btn-theme" type="button" block onClick={this.onClick}>
                  Get Started!</Button>
              </div>
            </Col>
          </Row>
        </Grid>
      </header>
    );
  }

  onClick = () => {
    appHistory.push("/auth/signup");
  }
}

export default Header


// WEBPACK FOOTER //
// ./src/entries/Static/Header.js